import { Skeleton } from '@mui/material'
import styled from 'styled-components';
import { sdsGrayscale } from '../../theme/sds-tokens';
import { chartCardSurfaceDark } from '../home/charts/chartColors';

export const SkeletonCardNR1Container = styled.div<{ themeState: { isDark: boolean } }>`
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  align-items: center;
  column-gap: 16px;
  flex: 1 1 0;
  box-sizing: border-box;
  padding: 14px 16px 14px 18px;
  background: ${props => (props.themeState.isDark ? chartCardSurfaceDark : sdsGrayscale[0])};
  border: 1px solid ${props => (props.themeState.isDark ? 'rgba(255, 255, 255, 0.08)' : sdsGrayscale[20])};
  border-left: 4px solid ${props => (props.themeState.isDark ? 'rgba(255, 255, 255, 0.16)' : sdsGrayscale[20])};
  border-radius: 12px;
`;

export const SkeletonCardValue = styled(Skeleton)``;

export const SkeletonCardTitle = styled(Skeleton)`
  && {
    margin: 0 0 4px 0;
  }
`;

export const SkeletonCardDescription = styled(Skeleton)``;